import { AccessCodeDetails, BundleComponentDetails, OfferDetails } from './interfaces/access-code.interface';

export interface AccessCodeProductClassification {
  product: string;
  categories: string[];
  redeemEligible: boolean;
}

const CONNECT = 'Connect';
const EBOOK = 'eBook';

export function classifyAccessCodeProduct(details: AccessCodeDetails): AccessCodeProductClassification {
  const products = (details.offers || []).map(classifyOffer).filter(Boolean) as string[];
  const uniqueProducts = [...new Set(products)];
  const categories = (details.offers || [])
    .map(getMainCategory)
    .filter((category): category is string => !!category);
  const uniqueCategories = [...new Set(categories)];

  return {
    product: uniqueProducts.join(', '),
    categories: uniqueCategories,
    redeemEligible: products.some(product => product === EBOOK || product.startsWith(CONNECT))
  };
}

function classifyOffer(offer: OfferDetails): string | undefined {
  const mainCategory = getMainCategory(offer);
  if (!mainCategory) {
    return undefined;
  }

  if (mainCategory.toLowerCase() !== 'connect') {
    return normalizeProductName(mainCategory);
  }

  const formats = getBundleComponents(offer)
    .map(component => component.format?.toLowerCase())
    .filter((format): format is string => !!format);
  const hasProctorio = formats.includes('proctorio-plus');
  const hasSharpen = formats.includes('sharpen-companion') ||
    (offer.fulfillments || []).some(fulfillment => fulfillment.category?.toLowerCase() === 'sharpen-companion');
  const addOns = [hasSharpen ? 'Sharpen Companion' : '', hasProctorio ? 'Proctorio Plus' : ''].filter(Boolean);
  return [CONNECT, ...addOns].join(' + ');
}

function getMainCategory(offer: OfferDetails): string | undefined {
  return (offer.fulfillments || []).find(fulfillment =>
    !!offer.isbn && fulfillment.isbn === offer.isbn
  )?.category;
}

function getBundleComponents(offer: OfferDetails): BundleComponentDetails[] {
  return offer.edoms?.bundleComponents ||
    (offer.edoms?.bundleComponent ? [offer.edoms.bundleComponent] : undefined) ||
    offer.bundleComponents ||
    (offer.bundleComponent ? [offer.bundleComponent] : []) || [];
}

function normalizeProductName(category: string): string {
  return category.toLowerCase() === 'ebook' ? EBOOK : category;
}